<script>
import {ref, reactive} from 'vue';

export default {
    inheritAttrs: false,
    props: {
        type: {
            type: String,
            default: 'fields'
        },
        initial: {
            type: Array,
            default: [],
        },
        form: {
            type: Array,
            default: [],
        }
    },

    render() {
        return this.$slots.default({
            add: this.add,
            fields: this.fields,
            updateType: this.updateType,
            removeField: this.removeField,
            getValue: this.getValue,
        })
    },

    setup({type, initial, form}) {
        const currentType = ref(type)
        const updateType = (event) => {
            console.log(event.target.value);
            currentType.value = event.target.value
        }

        const fields = reactive(initial)
        const add = () => {
            fields.push(currentType.value)
        }

        const removeField = (index) => {
            fields.splice(index, 1);
        }

        const getValue = (key, field) => {
            if(form && form[key]) {
                return form[key][field] || null;
            }

            return null;
        }

        return {
            currentType,
            add,
            updateType,
            removeField,
            getValue,
            fields,
        }
    }
}
</script>
